class HeroVideo {
  constructor() {
    this.videos = document.querySelectorAll('.js-video-html');

    if (!this.videos.length) {
      return;
    }

    this.breakpoint = window.matchMedia('(min-width: 1024px)');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.videos.forEach(video => this.setupVideo(video));
  }

  setupVideo(video) {
    const isHeroVideo = !!video.closest('.js-block-hero');

    // The hero background video is skipped below the desktop breakpoint (avoids
    // downloading large ambient footage on mobile) and when the user prefers
    // reduced motion — the poster image stays visible in both cases.
    if (
      isHeroVideo &&
      (!this.breakpoint.matches || this.reducedMotion.matches)
    ) {
      return;
    }

    const { url, autoplay, loop, muted, controls, poster } = video.dataset;
    const shouldAutoplay = autoplay !== '0' && !this.reducedMotion.matches;

    const videoElement = document.createElement('video');
    videoElement.src = url;
    videoElement.loop = loop !== '0';
    videoElement.controls = controls === '1';
    videoElement.preload = 'auto';
    videoElement.playsInline = true;
    videoElement.setAttribute('playsinline', '');

    if (poster) {
      videoElement.poster = poster;
    }

    // Autoplay only works if the element is muted before playback starts, so the
    // `muted` IDL property (not just the attribute) must be set ahead of play().
    if (shouldAutoplay || muted !== '0') {
      videoElement.muted = true;
      videoElement.setAttribute('muted', '');
    }

    if (shouldAutoplay) {
      videoElement.autoplay = true;
    }

    video.appendChild(videoElement);

    if (isHeroVideo) {
      const heroBlock = video.closest('.js-block-hero');
      const image = heroBlock
        ? heroBlock.querySelector('.c-block-hero__image')
        : null;

      videoElement.addEventListener('loadedmetadata', () => {
        if (image) {
          image.classList.add('u-d-none-large');
        }
      });
    }

    videoElement.load();

    if (shouldAutoplay) {
      const playPromise = videoElement.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        // Autoplay can still be rejected by the browser's policy; fail silently
        // and leave the poster/controls as the fallback.
        playPromise.catch(() => {});
      }
    }
  }
}

export default new HeroVideo();



// WEBPACK FOOTER //
// ./src/scripts/modules/hero-video.js